import { UserPermissionByIdResponse } from "../../types/permissionTypes";
import { callWorkflowGET } from "../generic";
import { USER_PERMISSION_ENDPOINTS } from "./endpoints";

export const getUserPermissionByIdSlice = (userId: string) =>
  callWorkflowGET<UserPermissionByIdResponse>(
    USER_PERMISSION_ENDPOINTS.USER_PERMISSION_BY_ID(userId),
  );
